import type {
	AiCreditsIncentiveDefinition,
	AiCreditsIncentiveItem,
} from '../models/ai-credits-incentive.model';

export function createDefaultAiCreditsIncentiveItems(): AiCreditsIncentiveItem[] {
	return AI_CREDITS_INCENTIVE_DEFINITIONS.map(definition => ({
		...definition,
		status: 'available',
		proofUrl: null,
	}));
}

export const G2_REVIEW_URL = 'https://www.g2.com/products/jepto/reviews';

export const JEPTO_HOMEPAGE_URL = 'https://www.jepto.com';

export const AI_CREDITS_INCENTIVE_DEFINITIONS: readonly AiCreditsIncentiveDefinition[] =
	[
		{
			id: 'g2-review',
			title: 'Write G2 review',
			monthlyCredits: 500,
			modalTitle: 'Leave a G2 review',
			description:
				'Leave us an honest review on the software review site G2 and wait for it to be published. Once it’s live, open your published review, copy the link from your browser, and paste it below. You’ll earn 500 AI credits now, and 500 more every month it stays live.',
			urlLabel: 'Review URL',
			urlInputMode: 'url',
			urlPlaceholder: 'https://www.g2.com/products/jepto/reviews/...',
			externalCta: {
				label: 'Leave a review on G2',
				url: G2_REVIEW_URL,
			},
		},
		{
			id: 'link-back',
			title: 'Link back to Jepto',
			monthlyCredits: 500,
			modalTitle: 'Link back to Jepto',
			description:
				'Add a link to any page of jepto.com from a page on your own website, then paste that page’s URL below. You’ll earn 500 AI credits now, and 500 more every month it stays live.',
			footerNote:
				'We check the page when you submit it, and again each month. It needs to be on your own domain, publicly reachable, and indexable, and the link still live to keep earning.',
			urlLabel: 'Page URL',
			urlInputMode: 'account-path',
			urlPlaceholder: 'page-that-links-to-jepto',
		},
	];
